const basePath = '/notifications';

export class NotificationPath {
  static index() {
    return basePath;
  }
}
